import styled from "styled-components";

const TableBody = styled.tbody`
  background: ${({ theme }) =>
    theme.contentBackground || theme.defaultBackground};
`;

export default TableBody;
